import UtilsServiceClient from "./Clients/UtilsServiceClient";

export const addLog = (logs) => {
	return UtilsServiceClient.addBatchLogEntry({ logs });
};

export const addLogActivity = (activities) => {
	return UtilsServiceClient.addBatchActivityEntry({ activities });
};
